(function(){
	var querystring = avm.require('avast.url.unserialize')(),
		serialize = avm.require('avast.url.serialize'),
		asyncClientInfo = avm.require('avast.web.clientInfo'),
		surveyRequested = false,
		timeout;

// function GetURLParameter(sParam)
// {
//     var sPageURL = window.location.search.substring(1);
//     var sURLVariables = sPageURL.split('&');
//     for (var i = 0; i < sURLVariables.length; i++)
//     {
//         var sParameterName = sURLVariables[i].split('=');
//         if (sParameterName[0] == sParam)
//         {
//             return sParameterName[1];
//         }
//     }
// }

// var source2 = GetURLParameter('source2');

// 	var survey = {
// 		init: function(){
// 			var iframeContainer = document.getElementById('surveryDiv'),
// 				lang = this.getLangCode(),
// 				_params = {
// 					Q_Language: lang ? lang.toUpperCase() : '',
// 					ext_ref: querystring.p_hid ? querystring.p_hid : this.clientInfoHid(),
// 					source: 'avast',
// 					source2: source2
// 				},
// 				params = serialize(_params),
// 				iframe;

// 			params = params ? '?' + params : '';

// 			if(querystring.qp_sid && iframeContainer) {
// 				iframe = document.createElement('iframe');
// 				iframe.setAttribute("id", "myframe"); //We set the id to the iframe
// 				iframe.setAttribute("height", "1000px"); //We set the id to the iframe
// 				iframe.src = querystring.qp_sid ? 'https://survey.eu.qualtrics.com/jfe/form/' + querystring.qp_sid + params : '';
// 				iframeContainer.appendChild(iframe);
// 			}
// 		},
// 		getLangCode: function(){
// 			return querystring.p_lng || navigator.language || navigator.userLanguage;
// 		},
// 		clientInfoHid: function (){
// 			var client = (window.avastGlobals && window.avastGlobals.client) ? window.avastGlobals.client : null,
// 				hid = client ? client.p_hid : '';

// 			return hid;
// 		}
// 	};

// 	if (avastGlobals.client || querystring.p_hid) {
// 		survey.init();
// 	} else if (asyncClientInfo) {
// 		timeout =  setTimeout(function(){
// 			if(!surveyRequested){
// 				asyncClientInfo.off('change');
// 				survey.init();
// 			}
// 		}, 5000);

// 		asyncClientInfo.once('change', function(info){
// 			if(info && info.p_hid){
// 				surveyRequested = true;
// 				survey.init();
// 			}
// 		});
// 	}
})();

function sendBurgerTracking() {
	if (typeof URL === 'undefined' || typeof fetch === 'undefined' || typeof atob === 'undefined' || typeof Uint8Array === 'undefined') {
		return;
	}

	var url = new URL(window.location.href);
	var burgerParam = url.searchParams.get('burger');

	if (burgerParam) {
		var decoded = atob(burgerParam);
		var charCodes = [];

		for (var i = 0; i < decoded.length; i++) {
			charCodes.push(decoded.charCodeAt(i))
		}

		var body = new Uint8Array(charCodes);

		fetch('https://analytics.ff.avast.com/v4/receive/gpb', {
			method: 'POST',
			headers: { "Content-Type": "application/octet-stream" },
			body: body
		});
	}
}

// Burger tracking
sendBurgerTracking();

document.onload = function () {
	// Create IE + others compatible event handler
	var eventMethod = window.addEventListener ? "addEventListener" : "attachEvent";
	var eventer = window[eventMethod];
	var messageEvent = eventMethod == "attachEvent" ? "onmessage" : "message";

	// Listen to message from child window
	eventer(messageEvent,function(e) {
	  console.log('parent received message!:  ',e.data);
	},false);
}
